/* jslint browser: true */
/* global document */
import React, { Component } from 'react';
import ReactTable from 'react-table';
import Modal from 'react-modal';
import axios from 'axios';
import 'react-table/react-table.css';
import FormProfessionnel from './FormProfessionnel';
import { apiUrl } from '../lib/constants';

class ProfessionnelsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            proList: [],
            columns: [
                {
                    id: 'id',
                    Header: 'ID',
                    accessor: d => d.id_pro
                },
                {
                    id: 'etablissement',
                    Header: 'Etablissement',
                    accessor: d => d.etablissement
                },
                {
                    id: 'nom',
                    Header: 'Nom',
                    accessor: d => d.nom
                },
                {
                    id: 'ville',
                    Header: 'Ville',
                    accessor: d => d.ville
                },
                {
                    id: 'credits',
                    Header: 'Crédits',
                    accessor: d => d.credit
                },
                {
                    id: 'actif',
                    Header: 'Actif',
                    accessor: d => d.actif,
                    Cell: _props => (
                        <span className="number">
                            <input
                                readOnly
                                type="checkbox"
                                value="actif"
                                disabled
                                checked={_props.value}
                            />
                        </span>
                    )
                }
            ],
            data: [],
            isOpenModal: false,
            proId: undefined
        };
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidMount() {
        axios.get(`${apiUrl}/api/v1/isAdmin`).then(response => {
            if (response.data === 0) {
                window.location.href = '/login?c';
            }
        });
    }

    loadData() {
        axios.get(`${apiUrl}/api/v1/pro`).then(response => {
            this.setState({ proList: response.data, data: response.data });
        });
    }

    /**
     * Filtre le tableau de professionnels (this.state.proList) en fonction de la valeur saisi dans l'input Établissement (e.target.value)
     */
    filterData() {
        const query = document.querySelector('#search').value;
        const queryType = document.querySelector('#searchByName').checked;
        if (queryType) {
            this.setState({
                data: this.state.proList.filter(
                    pro =>
                        pro.nom.toLowerCase().indexOf(query.toLowerCase()) !==
                        -1
                )
            });
        } else {
            this.setState({
                data: this.state.proList.filter(
                    pro =>
                        pro.etablissement
                            .toLowerCase()
                            .indexOf(query.toLowerCase()) !== -1 ||
                        pro.ville.toLowerCase().indexOf(query.toLowerCase()) !==
                            -1 ||
                        pro.nom.toLowerCase().indexOf(query.toLowerCase()) !==
                            -1 ||
                        pro.adresse
                            .toLowerCase()
                            .indexOf(query.toLowerCase()) !== -1 ||
                        pro.prenom
                            .toLowerCase()
                            .indexOf(query.toLowerCase()) !== -1 ||
                        pro.siret.toLowerCase().indexOf(query.toLowerCase()) !==
                            -1
                )
            });
        }
    }

    openModal(row = undefined) {
        row === undefined
            ? this.setState({ isOpenModal: true, proId: row })
            : this.setState({ isOpenModal: true, proId: row.original.id_pro });
    }

    closeModal() {
        this.setState({ isOpenModal: false, proId: undefined });
    }

    render() {
        return (
            <div className="pro-list-wrapper">
                <div className="top-part">
                    <h3 className="pro-list-title">
                        Gestion des professionnels
                    </h3>
                    <button
                        className="btn myBtn pull-right"
                        style={{ marginTop: '0' }}
                        onClick={() => this.openModal()}
                    >
                        Ajouter
                    </button>
                    <div style={{ whiteSpace: 'nowrap' }}>
                        <label htmlFor="search">Etablissement:</label>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            onChange={e => this.filterData()}
                        />
                        <input
                            type="checkbox"
                            name="searchByName"
                            id="searchByName"
                            onChange={e => this.filterData()}
                        />
                        <label htmlFor="searchByName">
                            Rechercher dans le nom seulement
                        </label>
                    </div>
                </div>
                <ReactTable
                    data={this.state.data}
                    defaultPageSize={10}
                    previousText="Précédent"
                    nextText="Suivant"
                    loadingText="Chargement..."
                    noDataText="Aucune informations"
                    ofText="sur"
                    rowsText="lignes"
                    showPageSizeOptions={false}
                    style={{ margin: '0 10px' }}
                    columns={this.state.columns}
                    getTrProps={(state, rowInfo) => ({
                        onClick: () => this.openModal(rowInfo)
                    })}
                />
                <Modal
                    isOpen={this.state.isOpenModal}
                    onRequestClose={this.closeModal}
                    shouldCloseOnOverlayClick={false}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 9
                        },
                        content: {
                            position: 'absolute',
                            margin: '0',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            border: '1px solid rgb(204, 204, 204)',
                            background: 'rgb(249, 249, 249)',
                            overflow: 'auto',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: 'unset',
                            bottom: 'unset',
                            maxHeight: '95vh',
                            width: '100%',
                            maxWidth: '900px'
                        }
                    }}
                >
                    <div className="content-box">
                        <div className="form-header-pro">
                            {this.state.proId !== undefined ? (
                                <h3>Édition d&apos;un professionnel</h3>
                            ) : (
                                <h3>Création d&apos;un professionnel</h3>
                            )}
                            <span
                                role="button"
                                tabIndex="0"
                                onClick={this.closeModal}
                            >
                                <i
                                    className="fa fa-close fa-2x"
                                    style={{
                                        color: '#fff',
                                        position: 'absolute',
                                        top: '3px',
                                        right: '5px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </span>
                        </div>
                        {this.state.proId === undefined ? (
                            <FormProfessionnel
                                closeModal={this.closeModal}
                                admin
                                creation
                                loadData={this.loadData}
                            />
                        ) : (
                            <FormProfessionnel
                                closeModal={this.closeModal}
                                proId={this.state.proId}
                                admin
                                loadData={this.loadData}
                            />
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}

export default ProfessionnelsList;



// WEBPACK FOOTER //
// ./src/components/ProfessionnelsList.js